/**
 * Outlet & Register List Report
 *
 * Full inventory of outlets and registers across franchise partners
 * with open/closed status, type classification, and compliance metrics.
 */
import BaseReportPage, { ColumnDef, ColumnGroup } from './BaseReportPage'

const columns: ColumnDef[] = [
  { key: 'fp_code', label: 'FP Code' },
  { key: 'franchise_name', label: 'Franchise', type: 'text' },
  { key: 'last_sync_at', label: 'Data Age', type: 'sync_status' },
  { key: 'fp_status', label: 'FP Status' },
  { key: 'market', label: 'Market' },
  { key: 'register_name', label: 'Register Name', minWidth: 250, align: 'left', link: { field: 'register_edit_link', system: 'lightspeed' } },
  { key: 'outlet_name', label: 'Outlet', minWidth: 125, align: 'left' },
  { key: 'register_type', label: 'Register Type', minWidth: 150, filterable: true },
  { key: 'invoice_prefix', label: 'Prefix' },
  { key: 'sale_count', label: 'Sales', type: 'integer', align: 'right', link: { field: 'register_sales_ledger_link', system: 'lightspeed' } },
  { key: 'closure_days', label: 'Closes', type: 'integer', align: 'center', link: { field: 'closure_report_link', system: 'lightspeed' } },
  { key: 'closure_rate', label: 'Daily Close Rate', type: 'percentage', align: 'center', colorBands: [
    { max: 0.25, bg: '#fef0ef', text: '#B71C1C' },
    { max: 0.75, bg: '#fff3e0', text: '#E65100' },
    { min: 0.76, bg: '#e8f5e9', text: '#2E7D32' },
  ] },
  { key: 'is_open', label: 'Open now?', type: 'boolean_indicator' },
  { key: 'days_open', label: 'Open for (days)', type: 'integer', align: 'center', colorBands: [
    { min: 3, bg: '#fef0ef', text: '#B71C1C' },
  ] },
  { key: 'register_open_time', label: 'Opened at', type: 'date', align: 'center' },
  { key: 'register_close_time', label: 'Last close at', type: 'date' },
]

const columnGroups: ColumnGroup[] = [
  { label: null, columnKeys: ['fp_code', 'franchise_name', 'last_sync_at', 'fp_status', 'market'] },
  { label: 'Register', columnKeys: ['register_name', 'outlet_name', 'register_type', 'invoice_prefix'] },
  { label: 'Activity ({dateRange})', columnKeys: ['sale_count', 'closure_days', 'closure_rate'] },
  { label: 'Current Status', columnKeys: ['is_open', 'days_open', 'register_open_time', 'register_close_time'] },
]

export default function OutletRegisterListReport() {
  return (
    <BaseReportPage
      reportType="outlet_register_list"
      title="Outlet & Register List"
      description="Full inventory of outlets and registers across franchise partners with open/closed status."
      filterConfig={{
        showFpSelector: true,
        showFpStatus: true,
        showCountry: true,
        showRegion: true,
        showDateRange: true,
        defaultDateRange: 'last_30_days',
        requireDateRange: true,
        linkFpStatusToSearch: true,
      }}
      columns={columns}
      columnGroups={columnGroups}
      defaultSortColumn="franchise_name"
    />
  )
}
